module.exports = __webpack_public_path__ + "static/media/document-hover.9c61211f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/document-hover.svg
// module id = 860
// module chunks = 0